import Image from 'next/image';

import { Box, Flex, Heading, Text } from '@chakra-ui/react';

import { ContentContainer } from '~/components/container';
import { SectionHeader } from '~/components/section-header';
import { AccreditationValuesProps } from '~/features/accreditation/types';
import { BookIcon } from '~/features/experiments/ab_plp_redesign_2025/icons';

export function AccreditationValuesSection({ sectionTitle, sectionDescription, items }: AccreditationValuesProps) {
  return (
    <Flex as='section'>
      <ContentContainer contentMaxWidth='content-max-width-md'>
        <SectionHeader
          color='grey.500'
          containerProps={{ maxWidth: '900px', margin: '0 auto' }}
          descriptionSlot={sectionDescription}
          iconSlot={<BookIcon color='grey.500' height='18px' width='18px' />}
          subtitle='The Learning Experience'
          titleSlot={
            <Heading
              as='h2'
              fontWeight='600'
              lineHeight='1.1'
              fontSize={{
                base: '2.5rem',
                md: '3.375rem',
              }}
            >
              {sectionTitle}
            </Heading>
          }
        />

        <Flex
          flexDirection={{ base: 'column', lg: 'row' }}
          gap={{ base: '8px', lg: '16px' }}
          mt={{ base: '40px', lg: '64px' }}
        >
          {items.map((item) => (
            <Flex
              key={item.title}
              bg='white'
              borderRadius='8px'
              flex='1'
              flexDirection={{ base: 'row', lg: 'column' }}
              gap='16px'
              padding={{ base: '16px', lg: '28px' }}
              paddingBottom={{ base: '16px', lg: '32px' }}
            >
              <Box display={{ base: 'none', lg: 'block' }}>
                <Image alt={item.title} height={48} quality={100} src={item.imageSrc} width={48} />
              </Box>
              <Flex flex={1} flexDirection='column' gap={{ base: '12px', lg: '24px' }}>
                <Flex alignItems='center' gap='20px'>
                  <Box display={{ base: 'block', lg: 'none' }}>
                    <Image alt={item.title} height={32} quality={100} src={item.imageSrc} width={32} />
                  </Box>
                  <Heading
                    as='h3'
                    fontWeight='600'
                    height={{ base: 'fit-content', lg: '48px' }}
                    lineHeight='1.1'
                    size='heading-7'
                    width={{ base: '100%', lg: '160px' }}
                  >
                    {item.title}
                  </Heading>
                </Flex>
                <Text color='grey.500' fontSize='sm'>
                  {item.description}
                </Text>
              </Flex>
            </Flex>
          ))}
        </Flex>
      </ContentContainer>
    </Flex>
  );
}
